import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardTitle, CardText, Button, ListGroup, ListGroupItem } from 'reactstrap';
import '../styles/DivisionCard.css'

const DivisionCard = props => (
    <Card>
        <CardBody>
            <CardTitle id="cTitle">{props.title}</CardTitle>
            <CardText><small>{props.introduction}</small></CardText>
            <hr />
            {props.buttons.map((button, idx) => 
                <Button id="cardButton" tag={Link} key={idx} block={true} to={button.navigateTo} color="info">{button.text}</Button>
            )}
            <h6>{props.buttonInfo}</h6>
            <ListGroup>
                {props.filelinks.map((file, idx) => 
                    <ListGroupItem key={idx}>
                        <a id="homeLink" target="_blank" rel="noopener noreferrer" href={file.link}>{file.name}</a>
                    </ListGroupItem>
                )}
            </ListGroup>
        </CardBody>
  </Card>
  );
  
  export default DivisionCard;
  


// WEBPACK FOOTER //
// ./src/components/DivisionCard.js